module.exports = __webpack_public_path__ + "static/atvinnuvega-b6d14b793ec63bbaf0905e7a179261f2.png";